import { validateRedirectUrl } from '@/utils/validate-redirect-url';

const GIFT_CODE_PARAM = 'gift_code';
const MY_ACCOUNT_PATH = '/my-account';
const DEFAULT_POST_SIGN_UP_REDIRECT_URL = '/application';

type SearchParamsLike = Pick<URLSearchParams, 'get'> | null | undefined;

export function resolveGiftCodeRedirectUrl(searchParams: SearchParamsLike): string | null {
  const giftCode = searchParams?.get(GIFT_CODE_PARAM)?.trim();

  if (!giftCode) {
    return null;
  }

  const giftCodeParams = new URLSearchParams({ [GIFT_CODE_PARAM]: giftCode });
  return `${MY_ACCOUNT_PATH}?${giftCodeParams.toString()}`;
}

export function resolvePostAuthRedirectUrl(
  searchParams: SearchParamsLike,
  fallback: string = DEFAULT_POST_SIGN_UP_REDIRECT_URL,
): string {
  const giftCodeRedirectUrl = resolveGiftCodeRedirectUrl(searchParams);

  if (giftCodeRedirectUrl) {
    return giftCodeRedirectUrl;
  }

  return validateRedirectUrl(searchParams?.get('redirect_url'), fallback);
}

export function resolvePostSignUpRedirectUrl(
  searchParams: SearchParamsLike,
  fallback: string = DEFAULT_POST_SIGN_UP_REDIRECT_URL,
): string {
  return resolvePostAuthRedirectUrl(searchParams, fallback);
}
